export const loaderWrapperStyles = {
  display: 'flex',
  justifyContent: 'center',
  mt: 5,
};